import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import OrderAndDealServices from '../../services/Order&DealServices';
function AddOrderAndDeals() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    title: '',
    subtitle: '',
    sequence: '',
    image: null, 
    status:"show"
  });
const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); 
  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };
  //   // Handle form submission
 const handleSubmit = async (event) => {
  event.preventDefault();

  if (!formValues.title.trim()) {
    alert('Title is required');
    return;
  }
  if (!formValues.image) {
    alert('Please upload an image');
    return;
  }

  setLoading(true);
  try {
    const formData = new FormData();
    formData.append('title', formValues.title.trim());
    formData.append('subtitle', formValues.subtitle.trim());
    formData.append('sequence', Number(formValues.sequence) || 1);
    formData.append('status', formValues.status);
    formData.append('image', formValues.image);

    await OrderAndDealServices.createOrderAndDeals(formData);
    alert('Order created successfully');
    navigate('/offer-and-deals');
  } catch (error) {
    console.error('Failed to create Order', error);
    alert('Failed to create Order');
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">
               Add Offer
            </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Offer
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <div className="pe-1 mb-xl-0">
              <Link className="list-banner-btn" to="/offer-and-deals"> Offer&Deals List</Link>
            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
             
                <div className="input-field">
                 <label>Title<span className="red">*</span></label>
<input 
  type="text" 
  name="title" 
  value={formValues.title}
  onChange={handleInputChange} 
  className="form-control" 
  required 
  placeholder='New  Title' 
/>
                </div>
   <div className="input-field">
                 <label> Sub Title<span className="red">*</span></label>
<input 
  type="text" 
  name="subtitle" 
  value={formValues.subtitle}
  onChange={handleInputChange} 
  className="form-control" 
  required 
  placeholder='New Sub Title' 
/>
                </div>
                <div className='row'>
                  <div className="col-lg-12 col-md-6">
                    <div className="input-field">
                      <label>Select Sequence</label>
                      <select
                        className="form-control"
                        value={formValues.sequence}
                        onChange={handleInputChange}
                        name="sequence"
                      >
                        <option value="" disabled>
                          Please select
                        </option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                      </select>
                    </div>
                  </div>
                         <div className="col-lg-12 col-md-6">
                    <div className="input-field">
                      <label>Status</label>
                      <select
                        className="form-control"
                        value={formValues.status}
                        onChange={handleInputChange}
                        name="status"
                      >
                        {/* <option value="" disabled>
                          Please select
                        </option> */}
                        <option value="show">Active</option>
                        <option value="hide">InActive</option>

                      </select>
                    </div>
                  </div>
                </div>

                <div className="input-field">
                  <label>Upload<span className="red">*</span></label>
                  <input type="file" name="image" className="form-control" onChange={handleFileChange} required />
                  <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                  <div className="file-preview text-center">
                    <img id="uploadFile" src={previewImage} alt="your image" />
                  </div>
                </div>
        <button className="submit-green-btn" type="submit" disabled={loading}>
  {loading ? 'SUBMITTING...' : 'SUBMIT'}
</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddOrderAndDeals